import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-flags-menu',
  templateUrl: './flags-menu.component.html',
  styleUrls: ['./flags-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FlagsMenuComponent implements OnInit {
  public settings: Settings;
  constructor(
    public appSettings: AppSettings,
    public translate: TranslateService
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {}
  switchLang(lang: string) {
    localStorage.setItem('lang', JSON.stringify(lang));
    //this.translate.setDefaultLang(lang);
    this.translate.use(lang);
  }
}
